import React from 'react'
import { TrendingDown, Zap, Building2, Settings, Eye, DollarSign } from 'lucide-react'
import { useLocalization } from '../../hooks/useLocalization'

/**
 * Partnership Benefits Section Component
 * 
 * Displays the key benefits of partnering with EvoltBay
 */
const PartnershipBenefitsSection: React.FC = () => {
  const { t } = useLocalization()

  const benefits = [
    {
      icon: TrendingDown,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-100 dark:bg-blue-900',
      key: 'reducedFriction'
    },
    {
      icon: Zap,
      iconColor: 'text-green-600',
      bgColor: 'bg-green-100 dark:bg-green-900',
      key: 'fasterProcurement'
    },
    {
      icon: Building2,
      iconColor: 'text-purple-600',
      bgColor: 'bg-purple-100 dark:bg-purple-900',
      key: 'centralizedRfq'
    },
    {
      icon: Settings,
      iconColor: 'text-indigo-600',
      bgColor: 'bg-indigo-100 dark:bg-indigo-900',
      key: 'customWorkflow'
    },
    {
      icon: Eye,
      iconColor: 'text-orange-600',
      bgColor: 'bg-orange-100 dark:bg-orange-900',
      key: 'marketVisibility'
    },
    {
      icon: DollarSign,
      iconColor: 'text-teal-600',
      bgColor: 'bg-teal-100 dark:bg-teal-900',
      key: 'costSavings'
    }
  ]

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            {t('home.partnership.benefits.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit) => {
            const Icon = benefit.icon
            return (
              <div
                key={benefit.key}
                className="bg-white dark:bg-gray-700 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-600 hover:shadow-md transition-shadow"
              >
                <div className={`w-12 h-12 ${benefit.bgColor} rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className={`w-6 h-6 ${benefit.iconColor}`} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {t(`home.partnership.benefits.${benefit.key}.title`)}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {t(`home.partnership.benefits.${benefit.key}.description`)}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default PartnershipBenefitsSection
